import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { isValidElement, ReactNode } from "react"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Human-readable labels for backend PractitionerType enum values (e.g. "LIFE_COACH" -> "Life Coach")
const practitionerTypeLabels: Record<string, string> = {
  COUNSELLOR: "Counsellor",
  LIFE_COACH: "Life Coach",
  OCCUPATIONAL_THERAPIST: "Occupational Therapist",
  PSYCHOLOGIST: "Psychologist",
};

export function formatPractitionerType(type: string): string {
  return (
    practitionerTypeLabels[type] ??
    type
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  );
}

export function formatPractitionerTypes(types?: string[]): string | undefined {
  return types?.map(formatPractitionerType).join(", ");
}

// Flattens JSX (e.g. text mixed with <br />) into plain text for use in
// JSON-LD schema fields, which only accept strings.
export function reactNodeToText(node: ReactNode): string {
  const flatten = (n: ReactNode): string => {
    if (n === null || n === undefined || typeof n === "boolean") return "";
    if (typeof n === "string" || typeof n === "number") return String(n);
    if (Array.isArray(n)) return n.map(flatten).join(" ");
    if (isValidElement<{ children?: ReactNode }>(n)) {
      if (n.type === "br") return " ";
      return flatten(n.props.children);
    }
    return "";
  };

  return flatten(node).replace(/\s+/g, " ").trim();
}
